class AnchorTabNavigator {
    constructor(options = {}) {
        this.$anchorLinks = $('.anchor-tabs-ul a');
        this.$anchorTabs = $('.anchor-tabs-wrapper');
        this.$anchorTabsUl = $('.anchor-tabs-ul');
        this.scrollOffset = options.scrollOffset || 100;
        this.scrollThreshold = $(window).width() <= 768 ? 1500 : 1200;
        this.isScrolling = null;

        this.init();
    }

    init() {
        // this.updateOffsets();
        this.handleURLParam();

        this.$anchorLinks.on('click', this.handleClick.bind(this));

        $(window)
            .on('scroll', () => this.throttle(() => this.handleScroll(), 100))
            .on('resize', () => this.throttle(() => this.updateOffsets(), 250));
    }

    throttle(callback, delay) {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(callback, delay);
    }

    updateOffsets() {
        let visibleCount = 0;

        this.$anchorLinks.each(function () {
            const target = $(this.getAttribute('href'));
            const isVisible = !!target.length;
            $(this).parent("li").toggle(isVisible);
            if (isVisible) visibleCount++;
        });

        if (visibleCount <= 1) {
            this.$anchorTabs.hide();
            return false;
        } else {
            this.$anchorTabs.show();
            return true;
        }
    }

    handleClick(e) {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        const target = $(href);
        if (target.length) {
            // 修改 URL 参数（不跳转）
            const url = new URL(window.location);
            url.searchParams.set('tab', href.replace('#', ''));
            window.history.replaceState({}, '', url);

            // 平滑滚动
            $('html, body').animate({
                scrollTop: target.offset().top - this.scrollOffset
            }, 500);
        }
    }

    handleScroll() {
        if (!this.updateOffsets()) return;

        const scrollTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        const docHeight = $(document).height();
        const isNearBottom = scrollTop + windowHeight >= docHeight - 200;

        this.$anchorTabs.toggle(scrollTop > this.scrollThreshold && !isNearBottom);

        let closestAnchor = null;
        let minDistance = Infinity;

        this.$anchorLinks.removeClass('active');
        this.$anchorLinks.each((_, el) => {
            const target = $(el.getAttribute('href'));
            if (target.length) {
                const distance = Math.abs(target.offset().top - scrollTop - this.scrollOffset);
                if (distance < minDistance) {
                    minDistance = distance;
                    closestAnchor = el;
                }
            }
        });
        

        if (closestAnchor) {
            $(closestAnchor).addClass('active');
        }
    }

    handleURLParam() {
        const params = new URLSearchParams(window.location.search);
        const tabTarget = params.get('tab');
        if (tabTarget) {
            const targetEl = $('#' + tabTarget);
            if (targetEl.length) {
                $('html, body').scrollTop(targetEl.offset().top - this.scrollOffset);
                this.$anchorLinks.removeClass('active');
                this.$anchorLinks.filter(`[href="#${tabTarget}"]`).addClass('active');
            }
        }
    }
}

// 启动
document.addEventListener('DOMContentLoaded', function () {
    new AnchorTabNavigator();
});
